<template>
  <div class="bg-white borderd">
    <div class="block px-10 py-2 mx-auto mt-0">

      <input type="text" class="w-full mt-1 mb-3 form-input" v-model="addUrlValue" @keyup.enter="onAddUrl" placeholder="url..." />

      <table v-if="urlList.length !== 0" class="w-full table-fixed">
        <tr class="border-b">
          <td class="px-4 py-2 text-gray-600 uppercase w-100">URL</td>
          <td class="px-4 py-2 text-gray-600 uppercase">Callback</td>
          <td class="px-4 py-2 text-gray-600 uppercase">Signout</td>
          <td class="px-4 py-2 text-gray-600 uppercase">CORS</td>
        </tr>

        <tbody>
          <tr v-for="u in urlList" :key="u" class="bg-white">
            <td class="px-4 py-2 text-gray-900">
              {{u}}
            </td>
            <td class="px-4 py-2 text-gray-900">
              <input id="redirectUris" type="checkbox" @input="checkboxToggle($event.target,u)" :checked="checkArray('redirectUris',u)" />
            </td>
            <td class="px-4 py-2 text-gray-900">
              <input id="postLogoutRedirectUris" type="checkbox" @input="checkboxToggle($event.target,u)" :checked="checkArray('postLogoutRedirectUris',u)" />
            </td>
            <td class="px-4 py-2 text-gray-900">
              <input id="allowedCorsOrigins" type="checkbox" @input="checkboxToggle($event.target,u)" :checked="checkArray('allowedCorsOrigins',u)" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import lodash from "lodash";

export default {
  name: "clienturls",
  data() {
    return {
      addUrlValue: ""
    };
  },
  computed: {
    ...mapGetters("clientsStore", ["current"]),
    urlList() {
      return lodash.union(
        this.current.allowedCorsOrigins,
        this.current.redirectUris,
        this.current.postLogoutRedirectUris
      );
    }
  },
  methods: {
    ...mapActions("clientsStore", ["save"]),
    checkArray(p, v) {
      return !!this.current[p] && this.current[p].includes(v);
    },
    async checkboxToggle(target, item) {
      if (target.checked) {
        this.current[target.id].push(item);
      } else {
        let n = this.current[target.id].indexOf(item);
        this.current[target.id].splice(n, 1);
      }
      await this.save();
    },
    async onAddUrl() {
      this.current["redirectUris"].push(this.addUrlValue);
      await this.save();
    }
  }
};
</script>
